import React, { useState } from 'react';
import DataTable from 'react-data-table-component';

const ItemSearchPopup = ({ items, onSelectItem, onClose, initialSearchTerm }) => {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm || '');

  const filteredItems = items.filter(item =>
    item.no.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      name: 'Type',
      selector: row => row.type,
      sortable: true,
    },
    {
      name: 'Product Lot',
      selector: row => row.productLot,
      sortable: true,
    },
    {
      name: 'No',
      selector: row => row.no
      ,
      sortable: true,
    },
    {
      name: 'Unit of Measure',
      selector: row => row.uom,
      sortable: true,
    },
    {
      name: 'Description',
      selector: row => row.description
      ,
      sortable: true,
    },
    {
      name: 'Quantity',
      selector: row => row.Quantity,
      sortable: true,
    },
  ];

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h5>Select Item</h5>
          <button onClick={onClose} className="close-btn btn btn-danger">close</button>
        </div>
        <input
          type="text"
          placeholder="Search by Item No or Description"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
          autoFocus
        />
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          highlightOnHover
          pointerOnHover
          onRowClicked={onSelectItem}
          customStyles={{
            rows: {
              style: {
                minHeight: '33px',
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default ItemSearchPopup;